// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2d5WD","errorLogs":"styles_errorLogs__39MdJ"};